import { FunctionComponent, ReactNode, useEffect, useState } from "react";
import SegmentedControlAtom, {
  SegmentedControlAtomType,
} from "../../../src/atoms/segmented-control";

import styles from "./SegmentedControl.module.css";

export type SegmentedControlType = {
  className?: string;

  /** Variant props */
  size?: "sm" | "md" | "lg";

  /** Custom props */
  icon?: ReactNode;
  type?: "single" | "multi";
  items: SegmentedControlAtomType[];
  selected?: string[];
  onChange?: (e: string[]) => void;
};

export const SegmentedControl: FunctionComponent<SegmentedControlType> = ({
  className = "",
  size = "sm",
  type = "single",
  items = [],
  selected: externalSelected = [],
  onChange,
}) => {
  const [selected, setSelected] = useState(externalSelected);
  const handleClick = (value: string) => {
    let newSelected = [...selected];

    if (type === "single") {
      newSelected = [];
    }

    newSelected.includes(value)
      ? (newSelected = newSelected.filter((item) => item !== value))
      : newSelected.push(value);

    setSelected(newSelected);

    onChange?.(newSelected);
  };
  useEffect(() => {
    if (type === "single" && selected.length === 0 && items.length > 0) {
      setSelected([items[0].value || '']);
    }
  }, []);

  return (
    <div
      className={[
        styles.root,
        className,
        "quill-ui-next-component",
        "quill-ui-next-segmented-control",
      ].join(" ")}
      data-size={size}
      data-type={type}
      data-selected={selected}
    >
      {items.map((item) => (
        <SegmentedControlAtom
          key={item.value}
          {...item}
          size={size}
          type={type}
          isSelected={selected.includes(item.value || "")}
          onClick={handleClick}
        />
      ))}
    </div>
  );
};

SegmentedControl.displayName = "SegmentedControl";

export default SegmentedControl;
